module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Acknowledgments"
    }
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This volume is based on The Pleasures of Backwardness: Consumer Desire and Modernity in Eastern Europe, a conference that took place at the University of California, Berkeley in April 2015. Organized and hosted by Michael Dean, then a graduate student at UC Berkeley, the event brought together an interdisciplinary group of scholars for a lively discussion about the place of consumption in socialist societies and their institutions. The outcomes of these discussions are represented in chapters included in the volume. We gratefully acknowledge the contributions of the authors without whose hard work this volume would not be possible.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51746508","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Acknowledgments.vue
// module id = 75
// module chunks = 0